module.exports = __webpack_public_path__ + "img/bot3.c2468725.png";